import * as z from 'zod/v4';

export const yearSchema = z
  .number()
  .refine((year) => year >= 1900 && year <= 2100, {
    message: 'Year must be between 1900 and 2100',
  })
  .brand<'Year'>();

export const monthSchema = z
  .number()
  .refine((month) => month >= 1 && month <= 12, {
    message: 'Month must be between 1 and 12',
  })
  .brand<'Month'>();

export const daySchema = z
  .number()
  .refine((day) => day >= 1 && day <= 31, {
    message: 'Day must be between 1 and 31',
  })
  .brand<'Day'>();

export const dateSchema = z
  .string()
  .refine(
    (value) =>
      /^\d{4}-\d{2}-\d{2}$/.test(value) ||
      /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d+)?([+-]\d{2}:?\d{2}|Z))?$/.test(value),
    {
      message: 'Date string must be in YYYY-MM-DD or full ISO 8601 format with included offset',
    }
  )
  .refine((value) => !Number.isNaN(Date.parse(value)), {
    message: 'Invalid date string',
  })
  .transform((dateString) => {
    const datePart = dateString.slice(0, 10);
    const [yearStr, monthStr, dayStr] = datePart.split('-');
    const year = Number(yearStr);
    const month = Number(monthStr);
    const day = Number(dayStr);

    return new Date(year, month - 1, day);
  });
export type Year = z.infer<typeof yearSchema>;
export type Month = z.infer<typeof monthSchema>;
export type Day = z.infer<typeof daySchema>;
